import {
  DebugCatalogResponseDTO,
  DebugCatalogResponseSchema,
  DebugGrantItemResponseDTO,
  DebugGrantItemResponseSchema,
  DebugGrantLootResponseDTO,
  DebugGrantLootResponseSchema,
} from '@hexcrawl/shared-utils';
import { requestJson } from './api';

/** Bindings for the development debug cheats. Server-side gated on `cheatsAllowed`. */
export const debugApiService = {
  fetchCatalog(gameId: string): Promise<DebugCatalogResponseDTO> {
    return requestJson<DebugCatalogResponseDTO>({
      url: `/game/debug/catalog?gameId=${encodeURIComponent(gameId)}`,
      method: 'GET',
      schema: DebugCatalogResponseSchema,
    });
  },

  grantItem(gameId: string, defId: string): Promise<DebugGrantItemResponseDTO> {
    return requestJson<DebugGrantItemResponseDTO>({
      url: '/game/debug/grant-item',
      method: 'POST',
      data: { gameId, defId },
      schema: DebugGrantItemResponseSchema,
    });
  },

  grantLoot(gameId: string, tableId: string): Promise<DebugGrantLootResponseDTO> {
    return requestJson<DebugGrantLootResponseDTO>({
      url: '/game/debug/grant-loot',
      method: 'POST',
      data: { gameId, tableId },
      schema: DebugGrantLootResponseSchema,
    });
  },
};
